import React from 'react';
import { Auth, Authprops } from './Auth.types';
import { authReducer, initialState } from './Auth.reducer';
import { isJwtExpired } from '../../utils/jwt';

export const AuthContext = React.createContext<Auth>({
  token: '',
  isLoggedIn: false,
  isLoading: true,
  username: '',
  updateContext: () => {},
  clearContext: () => {},
});

const AuthProvider = ({ children }: Authprops) => {
  const [{ token, isLoggedIn, isLoading, username }, dispatch] = React.useReducer(authReducer, initialState);

  React.useEffect(() => {
    const username = window.localStorage.getItem('username');
    const token = window.localStorage.getItem('token');
    if (token && username && !isJwtExpired(token)) {
      dispatch({ type: 'UPDATE_CONTEXT', payload: { token, isLoggedIn: true, username } });
    } else if (token || username) {
      window.localStorage.removeItem('token');
      window.localStorage.removeItem('username');
    }
    dispatch({ type: 'UPDATE_LOADING' });
  }, []);

  const updateContext = React.useCallback((token: string, username: string) => {
    dispatch({ type: 'UPDATE_CONTEXT', payload: { token, isLoggedIn: true, username } });
    window.localStorage.setItem('token', token);
    window.localStorage.setItem('username', username);
  }, []);

  const clearContext = React.useCallback(() => {
    dispatch({ type: 'CLEAR_CONTEXT' });
    window.localStorage.removeItem('token');
    window.localStorage.removeItem('username');
  }, []);

  return (
    <AuthContext.Provider value={{ token, isLoggedIn, isLoading, username, updateContext, clearContext }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
